var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticStyle:{"padding":"30px 0"}},[_c('img',{attrs:{"alt":"Anniversario","src":require("../../assets/40anniversario2.jpg")}}),_c('onlyText',{attrs:{"text":_vm.text}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }